module.exports = __webpack_public_path__ + "img/71027.1903b43a.svg";